var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import OlVectorLayer from 'ol/layer/Vector';
import React, { Children, cloneElement, Fragment, useEffect, useMemo, useRef } from 'react';
import { useOpenLayers } from '../openlayers-context';
import { getEvents, getOptions } from '../utils';
var allVectorLayerOptions = {
  zIndex: undefined,
  label: undefined,
  opacity: undefined,
  source: undefined,
  visible: undefined,
  extent: undefined,
  minResolution: undefined,
  maxResolution: undefined
};
var allVectorLayerEvents = {
  'change:visible': undefined,
  postrender: undefined,
  pointermove: undefined,
  prerender: undefined
};

var VectorLayer = _ref => {
  var {
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    map,
    layerRef,
    featureCollection
  } = useOpenLayers();
  var memoizedLayerOptions = useMemo(() => getOptions(Object.assign(allVectorLayerOptions, props)), [props]);
  var memoizedLayerEvents = useMemo(() => getEvents(allVectorLayerEvents, props), [props]);
  var vectorLayerRef = useRef(new OlVectorLayer(_objectSpread(_objectSpread({}, memoizedLayerOptions), {}, {
    properties: {
      reference: props.reference
    }
  })));
  useEffect(() => {
    if (!map) return;
    var currentLayer = vectorLayerRef.current;
    map.addLayer(currentLayer);
    return () => {
      map.removeLayer(currentLayer);
    };
  }, [map]);
  useEffect(() => {
    var _currentLayer$getSour, _currentLayer$getSour2;

    var currentLayer = vectorLayerRef.current;

    if (layerRef) {
      layerRef.current = currentLayer;
    }

    for (var eventName in memoizedLayerEvents) {
      // TODO: This should not be any. Fix this.
      currentLayer.on(eventName, memoizedLayerEvents[eventName]);
    }

    var onAddFeature = e => {
      if (featureCollection !== null && featureCollection !== void 0 && featureCollection.current && e.feature !== undefined) {
        featureCollection.current.push(e.feature); // Add `addFeatures` custom prop to layer so we can
        // Detect new features being added through propertychange event

        currentLayer.set('addFeatures', true);
      }
    };

    var onRemoveFeature = e => {
      if (e.feature !== undefined) {
        featureCollection === null || featureCollection === void 0 ? void 0 : featureCollection.current.remove(e.feature);
      }
    };

    (_currentLayer$getSour = currentLayer.getSource()) === null || _currentLayer$getSour === void 0 ? void 0 : _currentLayer$getSour.on('addfeature', onAddFeature);
    (_currentLayer$getSour2 = currentLayer.getSource()) === null || _currentLayer$getSour2 === void 0 ? void 0 : _currentLayer$getSour2.on('removefeature', onRemoveFeature);
    return () => {
      var _currentLayer$getSour3, _currentLayer$getSour4;

      (_currentLayer$getSour3 = currentLayer.getSource()) === null || _currentLayer$getSour3 === void 0 ? void 0 : _currentLayer$getSour3.un('addfeature', onAddFeature);
      (_currentLayer$getSour4 = currentLayer.getSource()) === null || _currentLayer$getSour4 === void 0 ? void 0 : _currentLayer$getSour4.un('removefeature', onRemoveFeature);
    };
  }, [featureCollection, layerRef, memoizedLayerEvents]);
  return /*#__PURE__*/React.createElement(Fragment, null, Children.map(children, child => child ? /*#__PURE__*/cloneElement(child, {
    olLayer: vectorLayerRef.current
  }) : undefined));
};

export default VectorLayer;